










































import { Component, Prop, Vue } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import { WidgetThemesDictionary } from '@/models/Widget/themes';
import {
  IWidgetSettingsFormData,
  WidgetPosition
} from '@/models/Widget/settings';

import ButtonTabs from '@/components/molecules/ButtonTabs/ButtonTabs.vue';
import ButtonTabsV2 from '@/componentsV2/molecules/ButtonTabs/ButtonTabs.vue';
import MockupWidgetPreview from '@/componentsV2/organisms/MockupWidgetPreview/MockupWidgetPreview.vue';
import { configWidgetFormDataFactory } from '@/views/Onboarding/helpers';
import { isExternalOauthSessionOnline } from '@/router/router-utils';
import WidgetIcon from '../MockupWidgetPreview/WidgetIcon.vue';
import WidgetPopover from '../MockupWidgetPreview/WidgetPopover.vue';
import WidgetWelcomeMessage from '../MockupWidgetPreview/WidgetWelcomeMessage.vue';

type Style = Record<string, string | number>;

@Component({
  components: {
    ButtonTabs,
    ButtonTabsV2,
    MockupWidgetPreview,
    WidgetIcon,
    WidgetPopover,
    WidgetWelcomeMessage
  }
})
export default class WidgetPreviewBox extends Vue {
  @Prop({ required: true, default: configWidgetFormDataFactory() })
  formData!: IWidgetSettingsFormData;

  get tPrefix() {
    return 'common.components.devicePreviewBox';
  }

  get tabs(): string[] {
    return ['Widget', 'Button'];
  }

  get activeTab() {
    if (this.formData.previewState === 'popover') return 'Widget';
    return 'Button';
  }

  get widgetConfigPropsHasValues() {
    const hasValues = Object.keys(this.formData || {}).length;

    return !!hasValues;
  }

  get popoverTheme() {
    if (!this.widgetConfigPropsHasValues) return '';

    return this.formData.widgetStyle.color;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get positionStyle() {
    if (!this.widgetConfigPropsHasValues) return {};

    const currentPlacement = this.formData.placement.positioning;
    const { horizontally, vertically } = this.formData.placement.desktop;

    const alignmentMap: Record<WidgetPosition, Style> = {
      bottomRight: {
        right: `${horizontally}px`,
        bottom: `${vertically}px`
      },
      bottomLeft: {
        left: `${horizontally}px`,
        bottom: `${vertically}px`
      }
    };

    if (!alignmentMap[currentPlacement]) return {};

    return alignmentMap[currentPlacement];
  }

  get isNewOnlineSignup() {
    return isExternalOauthSessionOnline();
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get businessLogo() {
    const business = this.businessInfo;

    if (!business || !business.logo) return '';

    return business.logo.publicPath.large;
  }

  get themeSettings() {
    return WidgetThemesDictionary[this.formData.widgetStyle.color];
  }

  get welcomePlacementStyle() {
    if (!this.widgetConfigPropsHasValues) return {};

    const position = this.formData.placement.positioning;
    if (position === 'bottomLeft') {
      return {
        left: 0
      };
    }

    return {
      right: 0
    };
  }

  get placementDirection() {
    const widgetSettings = this.formData;

    if (!widgetSettings) return '';

    const { placement } = widgetSettings;
    const { positioning } = placement;

    return positioning;
  }

  get themeTextColor() {
    return this.themeSettings.primaryGradientTextColor || '#FFF';
  }

  handleChangeTab(tab: string) {
    eventBus.$emit('widgetConfigFormSetFormData', {
      ...this.formData,
      previewState: tab === 'Widget' ? 'popover' : 'welcomeMessage'
    });
  }
}
